import { Table } from 'react-bootstrap';
import { ToggleIcon } from '../../../shared/ToggleIcon';
import ExpandableRow from '../../shared/ExpandableRow';
import { ICaseAuditLog } from '../../../interfaces/ICase';
import { IAuditLogDetail } from '../../../interfaces/IAudit';
import { useEffect, useState } from 'react';
import Common from '../../../stores/Common';

export function CaseAuditRow(props: {
    activeKeys?: string[];
    expandedByDefault?: boolean;
    caseAuditLog: ICaseAuditLog;
}) {
    const { caseAuditLog: caseAuditLog } = props;
    const [expanded, setExpanded] = useState<boolean>(false);

    const handleToggle = async () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        if (props.activeKeys?.includes(caseAuditLog.guid)) {
            setExpanded(true);
        } else if (!props.activeKeys?.includes(caseAuditLog.guid)) {
            setExpanded(false);
        }
    }, [props.activeKeys, caseAuditLog.guid]);

    return (
        <>
            <tr
                key={caseAuditLog.guid}
                style={{ verticalAlign: 'middle', cursor: 'pointer' }}
                onClick={handleToggle}
            >
                <td>
                    <ToggleIcon onClick={handleToggle} isOpen={expanded} />
                </td>
                <td>
                    <span className="nowrap">{caseAuditLog.user}</span>
                </td>
                <td>{Common.dateTimeFormatToLocal(caseAuditLog.date)}</td>
            </tr>
            <ExpandableRow
                isExpanded={expanded}
                colSpan={5}
                customDivStyles={{ padding: '1em 4em 0em' }}
                customTrStyles={{ backgroundColor: '#f5f5f5' }}
            >
                <Table size="sm">
                    <thead>
                        <tr>
                            <th style={{ width: 200 }}>Field Name</th>
                            <th style={{ width: 200 }}>From Value</th>
                            <th style={{ width: 150 }}>To Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {caseAuditLog.details?.map((log: IAuditLogDetail) => (
                            <tr>
                                <td>{log.fieldName}</td>
                                <td>{log.previousValue}</td>
                                <td>{log.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ExpandableRow>
        </>
    );
}
